<template>
    <div class="page noselect">
<!--        <div class="absBack">-->
<!--            <div onclick="window.history.back()">-->
<!--                <v-icon  medium dark>mdi-arrow-left</v-icon>-->
<!--            </div>-->
<!--        </div>-->

<!--        <h1 class="myTitle tablet">Impressum</h1>-->

        <v-container grid-list-md>

            <div class="text-left mt-7">
                <h2>Impressum</h2>
                <div class="spacer-15"></div>
              <CmsBlock blockName="Impressum"></CmsBlock>
<!--                <div><a href="https://www.demo1.appcoast.eu/impressum.html" target="_blank">https://www.demo1.appcoast.eu/impressum.html</a></div>-->
<!--              <div class="d-inline-block text-left" v-html="html"></div>-->
            </div>

<!--            <v-card-text>-->
<!--                <span class="headline">Kerstin Mencz</span><br>-->
<!--                Carl-Bosch-Str. 13<br>-->
<!--                67133 Maxdorf-->
<!--            </v-card-text>-->

<!--            <v-card-text>-->
<!--                Telefon: +49 (0) 176 48002516<br>-->
<!--                E-Mail: info(at)kikis-deko-und-aromashop.de<br>-->
<!--                Internet: kikis-deko-und-aromashop.de-->
<!--            </v-card-text>-->


<!--            <v-card-text>-->
<!--                <ul class="ll">-->
<!--                    <li><span class="font-weight-bold">Inhaber:</span><br>-->
<!--                        Kerstin Mencz-->
<!--                    </li>-->
<!--&lt;!&ndash;                    <li><span class="font-weight-bold">Registergericht</span><br>&ndash;&gt;-->
<!--&lt;!&ndash;                        Ludwigshafen/Rhein&ndash;&gt;-->
<!--&lt;!&ndash;                    </li>&ndash;&gt;-->
<!--&lt;!&ndash;                    <li><span class="font-weight-bold">Registernummer</span><br>&ndash;&gt;-->
<!--&lt;!&ndash;                        HRB 61757 Ludwigshafen/Rhein&ndash;&gt;-->
<!--&lt;!&ndash;                    </li>&ndash;&gt;-->
<!--&lt;!&ndash;                    <li><span class="font-weight-bold">Umsatzsteuer-Identifikationsnummer</span> gemäß § 27 a Umsatzsteuergesetz:<br>&ndash;&gt;-->
<!--&lt;!&ndash;                        DE 323 390 682&ndash;&gt;-->
<!--&lt;!&ndash;                    </li>&ndash;&gt;-->
<!--                </ul>-->
<!--            </v-card-text>-->


<!--            <v-card-text>-->
<!--                <span class="font-weight-bold">Haftungshinweis</span>: Trotz sorgfältiger inhaltlicher Kontrolle-->
<!--                übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind-->
<!--                ausschließlich deren Betreiber verantwortlich.-->
<!--            </v-card-text>-->

<!--            <div class="spacer-25"></div>-->

<!--            <v-card-text>-->
<!--                <div>Diese App wurde erstellt von</div>-->
<!--                <div>-->
<!--                    <a href="https://qsignal.de/" target="_blank">-->
<!--                        <img style="width: 200px; margin-top:15px" src="https://eu1-qsignal.s3.eu-central-1.amazonaws.com/images/qsignal-black.png"-->
<!--                             alt="Qsignal App Agentur">-->
<!--                    </a>-->
<!--                </div>-->
<!--            </v-card-text>-->



        </v-container>
    </div>
</template>

<script>
    import CmsBlock from "../components/CmsBlock.vue";

    export default {
        name: "Impressum",
      components: {CmsBlock},
        data: () => ({
            html: '' +
                ' Angaben gemäß § 5 TMG<br>' +
                '<br>' +
                // '    Frischkönig UG<br>' +
                // '    Windthorststr. 32<br>' +
                // '    48143 Münster<br>' +
                // '<br>' +
                // '    Vertreten durch:<br>' +
                // '    Mohamed Al-Asmar' +
                ''
        }),
    }
</script>

<style scoped lang="scss">
.ll{
    li{
        margin-bottom: 10px;
    }
}
</style>
